import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakeGetResponder, createFakePostResponder, isWildcard, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createLinesApi } from './';
export var createLinesApiTestKit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createLinesApi(parent, fakeHttp);
    var testKit = {
        whenGetLinesByIVR: function (ivrDto) {
            return createFakeGetResponder(fakeHttp, parent + "/lines/ivr?ivrId=" + (ivrDto === '*' ? '' : ivrDto.id));
        },
        whenGetLines: function () {
            return createFakeGetResponder(fakeHttp, parent + "/lines");
        },
        whenGetLineById: function (dto) {
            return createFakeGetResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId));
        },
        whenFindAvailablePhoneNumbers: function (dto) {
            return createFakeGetResponder(fakeHttp, parent + "/lines/availablePhoneNumbers/" + (isWildcard(dto) ? 'US' : dto.countryCode) + "?tollFree=" + (isWildcard(dto) ? 'true' : dto.tollFree));
        },
        whenUpdateLineDetails: function (dto) {
            var payload = dto === '*' ? {} : { name: dto.name, description: dto.description };
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId))(payload);
        },
        whenAddLine: function (dto) {
            return createFakePostResponder(fakeHttp, parent + "/lines/")(dto);
        },
        whenDeleteLine: function (dto) {
            return createFakeDeleteResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId));
        },
        whenGetSchedule: function (dto) {
            return createFakeGetResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule");
        },
        whenSetScheduleBusinessHours: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule/businesshours")(dto);
        },
        whenSetScheduleOpeningHours: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule/openingHours")(dto);
        },
        whenSetScheduleDownTimes: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule/downtimes")(dto);
        },
        whenSetOffHoursVoiceMessage: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule/businesshours/offHours/message/voice")(dto);
        },
        whenSetOffHoursSmsMessage: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule/offHours/message/text")(dto);
        },
        whenSetInbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled, ivrId: dto.ivrId };
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/inbound")(payload);
        },
        whenSetOutbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/outbound")(payload);
        },
        whenSetSmsInbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/sms/inbound")(payload);
        },
        whenSetSmsOutbound: function (dto) {
            var payload = dto === '*' ? {} : { enabled: dto.enabled };
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/sms/outbound")(payload);
        },
        whenSetDefault: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/setDefault")({});
        },
        whenSetSmsDefault: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/sms/setDefault")({});
        },
        whenSetInboundInactiveVoiceMessage: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/inactiveLineVoiceMessage")(dto);
        },
        whenGetLinesStatus: function () {
            return createFakeGetResponder(fakeHttp, parent + "/lines/status");
        },
        whenSetLinesStatus: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/lines/status")(dto);
        },
        whenSetScheduleId: function (dto) { return createFakePutResponder(fakeHttp, parent + "/lines/" + (dto === '*' ? '' : dto.lineId) + "/schedule")(dto); },
        whenSetAllLinesScheduleId: function (dto) { return createFakePutResponder(fakeHttp, parent + "/lines/schedule/all")(dto); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map